import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableAccount = QueryHookResult<
  typeof useAccountsQuery
>[number];

export const useAccountsQuery = createQueryHook(
  'shared.selectAccount',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    accounts: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          offset: 0,
          limit: 20,
        },
      },
      entries: {
        id: true,
        name: true,
        type: true,
        email: true,
        phone: true,
      },
    },
  }),
  {
    select: (data) => data.accounts.entries ?? [],
  },
);

export const SelectAccount = createEntityComboBox.remotelySearched(
  'SelectAccount',
  useAccountsQuery,
  {
    formatLabel: (entity) => entity.name,
    formatSubLabel: (entity) => `${entity.type} ・ ${entity.email}`,
  },
);
